'use client';

import Text, { TextTag, TextVariant } from '@pixum/text';
import { formatPrice, type LocaleIso } from 'utils';
import { useCartStore, type CartStore } from 'stores/cart';

interface ChildArticleAmountProps {
  childId: number;
  /** RSC-rendered quantity — fallback when Zustand has no override */
  quantity: number;
  /** RSC-rendered total price for this child (quantity × unitPrice) */
  summaryPriceGross: number;
  locale: LocaleIso;
  className?: string;
}

export function ChildArticleAmount({ childId, quantity, summaryPriceGross, locale, className }: ChildArticleAmountProps) {
  const childAmounts = useCartStore((s: CartStore) => s.cartLiveValues?.childAmounts);

  const liveQuantity = childAmounts?.[childId] ?? quantity;
  // Unit price is stable — compute from RSC props (summaryPriceGross / quantity).
  // Dividing stale RSC data gives the correct unit price since it does not change on qty mutations.
  const unitPrice = quantity > 1 ? summaryPriceGross / quantity : summaryPriceGross;
  const formattedUnitPrice = formatPrice(unitPrice, locale) ?? '';
  const display = liveQuantity > 1 ? `${liveQuantity} x ${formattedUnitPrice}` : formattedUnitPrice;

  return (
    <Text tag={TextTag.SPAN} variant={TextVariant.BODY} className={className}>
      {display}
    </Text>
  );
}
